var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"applicationInfo",attrs:{"title":_vm.$t('applicationInfoView.applicationInfo'),"icon":"cog"}},[_c('ApplicationInfoDetail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }